<template>
  <v-container class="modern-floor-control">
    <!-- Premium Header -->
    <v-row class="mb-8 align-center px-4">
      <div class="d-flex align-center py-4">
        <v-avatar size="48" color="primary lighten-4" class="mr-4 shadow-sm">
          <v-icon color="primary">fas fa-gamepad</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text">Control de Piso</div>
          <div class="caption grey--text font-weight-medium uppercase tracking-wider">Monitoreo y ejecución de procesos en tiempo real</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div style="width: 350px;">
        <v-select
          :items="machines"
          item-text="name"
          item-value="id"
          v-model="machine"
          placeholder="Seleccione área de producción"
          outlined
          dense
          hide-details
          prepend-inner-icon="fas fa-industry"
          class="modern-select shadow-sm"
          :loading="loading"
          clearable
        />
      </div>
    </v-row>

    <!-- Main Content Area -->
    <v-fade-transition mode="out-in">
      <div v-if="machine" :key="machine">
        <v-card outlined class="modern-card elevation-0 overflow-hidden bg-white">
          <machine-planner-alone
            :machine_id="machine" 
            :dragEnable="false"
            @displayWorkOrder="displayWorkOrder"
          />
        </v-card>
      </div>
      
      <div v-else key="empty" class="text-center py-16">
        <div class="empty-state-container pa-12 rounded-xl">
          <v-icon x-large color="primary lighten-3" class="mb-6 opacity-40" size="80">fas fa-microchip</v-icon>
          <h2 class="text-h5 font-weight-bold grey--text text--darken-2 mb-2">Listo para Monitorear</h2>
          <p class="body-1 grey--text text--darken-1 mb-8">Seleccione un área de producción en el menú superior para visualizar el avance y tareas pendientes.</p>
          <div class="d-flex justify-center gap-4">
            <v-chip outlined color="primary lighten-2" class="px-4 font-weight-bold">
              <v-icon x-small left>fas fa-check-circle</v-icon> Avance en Vivo
            </v-chip>
            <v-chip outlined color="primary lighten-2" class="px-4 font-weight-bold">
              <v-icon x-small left>fas fa-check-circle</v-icon> Registro de Tiempos
            </v-chip>
          </div>
        </div>
      </div>
    </v-fade-transition>

    <!-- Work Order Detail Dialog -->
    <v-dialog v-model="showWorkOrder" max-width="1200" transition="dialog-bottom-transition" persistent scrollable>
      <v-card outlined class="modern-card overflow-hidden">
        <work-order-card 
          :work_order="workOrderDisplay" 
          @close="showWorkOrder = false" 
          @refresh="fetch" 
        /> 
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { fetchMachines, getWorkOrder } from '@/api/production'
import MachinePlannerAlone from '@/components/production/MachinePlannerAlone.vue'
import WorkOrderCard from '@/components/production/WorkOrderCard'
import notifications from '@/utils/notifications'

export default {
  name: 'FloorControl',
  components: { MachinePlannerAlone, WorkOrderCard },
  data() {
    return {
      machines: [],
      loading: false,
      machine: null,
      showWorkOrder: false,
      workOrderDisplay: {},
      work_order_card_loading: false,
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      const query = 'enabled=true&ordering=sort'
      try {
        const res = await fetchMachines(query)
        this.machines = res
      } catch (e) {
        notifications.showError('Error al cargar áreas: ' + e)
      } finally {
        this.loading = false
      }
    },
    async displayWorkOrder(item) {
      // Handle different item structures if coming from different components
      const woId = item.product?.work_order?.id || item.work_order_id
      if (!woId) return
      
      try {
        const data = await getWorkOrder(woId)
        this.workOrderDisplay = data
        this.showWorkOrder = true
      } catch (e) {
        notifications.showError('Error al obtener OT: ' + e)
      }
    },
  },
  async mounted() {
    await this.fetch()
  }
}
</script>

<style scoped>
.modern-floor-control {
  max-width: 1600px;
}
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 16px !important;
}
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.empty-state-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 2px dashed rgba(0,0,0,0.05);
  max-width: 600px;
  margin: 0 auto;
}
.uppercase { text-transform: uppercase; }
.tracking-wider { letter-spacing: 1px; }
.opacity-40 { opacity: 0.4; }
.gap-4 { gap: 16px; }
.modern-select >>> .v-input__slot { border-radius: 12px !important; }
</style>